import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { lang } from "../Utils/lang";
import { localUrlEnum } from "../Utils/urlEnum";

export const ROUTER_DASHBOARD = {
  routes: ["/", "/login",localUrlEnum.companies, "*"],
};

export const MAIN_SLIDER_COMPANIES = [
  {
    name: lang.companies,
    path: localUrlEnum.companies,
    icon: <DirectionsCarIcon />,
    orderId: 0,
  },
];
